import { useQuery } from '@tanstack/react-query';

import { getV1IdentityCurrentBusinessPartnersOptions } from '../../api/generated/pap/@tanstack/react-query.gen';

/**
 * Query hook for the identity's Business Partners list, used by the
 * ReviewOrganizationModal search tab. Called when the search tab first
 * activates; result is cached for the modal's lifetime.
 *
 * Filters client-side (in the component) to BPs where the identity is actively
 * a member or owner (`bp.user?.identityId === identityId || isOwner === true`).
 * The `switch=nobp` requirement in the OpenAPI spec is not enforced by the
 * frontend today — this follows the same pattern as existing legacy usage.
 */
export const useIdentityCurrentBusinessPartners = (enabled: boolean) =>
  useQuery({
    ...getV1IdentityCurrentBusinessPartnersOptions(),
    enabled,
  });
